import { setSelectedOrderItemIds } from '../State/selectedOrderItemIds';

export default () => (dispatch) => {

  dispatch(setSelectedOrderItemIds([]));

}